import api from "./api";
// import SystemApi from "./systemApi";

export default class Login {
  static login = async (body: any, code?: string) => {
    const url = code ? `/Login?codigo=${code}` : "/Login?codigo=Z6B87N90";
    const response = await api.post(url, body, {
      headers: {
        novoLogin: "true",
      },
    });
    return response.data;
  };

  static login2 = async (body: any, code?: string) => {
    const url = code ? `/Login?codigo=${code}` : "/Login?codigo=Z6B87N90";
    const response = await api.post(url, body, {
      headers: {
        novoLogin: "true",
      },
    });
    return response;
  };

  static refreshToken = async (body: any) => {
    const response = await api.post("/RefreshToken", body);
    return response;
  };

  static GetNewTokenAfterDesactivatedScreen = async (body: any) => {
    const response = await api.post("/RefreshToken", body, {
      headers: {
        reativar: "true",
      },
    });
    return response.data;
  };

  static PostSms = async (email: string, type: string, tipoEnvio: string) => {
    // const ipCliente = await SystemApi.getIpAddress();
    const apiUrl = `codigoconfirmacao/novo?tipo=${type}&email=${email}&tipoEnvio=${tipoEnvio}`;
    const response = await api.post(apiUrl);
    return response.data;
  };

  static ValidateResetPasswordCode = async (
    email: string,
    type: string = "resetsenha",
    code: string
  ) => {
    // const ipCliente = await SystemApi.getIpAddress();
    const apiUrl = `codigoconfirmacao/validar?email=${email}&tipo=${type}&codigo=${code}`;
    const response = await api.post(apiUrl);
    return response.data;
  };

  static loginTipo = async () => {
    const response = await api.get("/Login/Tipo");
    return response.data;
  };

  static solicitacaoNovaSenha = async (obj: {}) => {
    const response = await api.post(
      `/LoginConfig/solicitacao-senha?modulo=${1}`,
      obj
    );
    return response.data;
  };

  static GetNewCodeEmail = async (type: string, email: string) => {
    // const ipCliente = await SystemApi.getIpAddress();
    const response = await api.post(
      `/CodigoConfirmacao/Novo?tipo=${type}&email=${email}`,
      {}
    );
    return response.data;
  };

  static changePassword = async (obj: {}) => {
    const response = await api.patch(
      `/LoginConfig/alterar-senha?modulo=${1}`,
      obj
    );
    return response.data;
  };
}
